import { gql } from '@apollo/client'

export const EDIT_SLOTS = gql`
    mutation editSlots($input: editEntityInput!) {
        editEntity(input: $input) {
            success
            entity {
                guid
                ... on Event {
                    children {
                        guid
                        slots
                        alreadySignedUpInSlot
                    }
                    slotsAvailable {
                        name
                        subEventGuids
                    }
                }
            }
        }
    }
`
